import React from 'react';
import Select from 'react-select';

const InformacionCongreso = ({ 
  formData, 
  handleSelectChange, 
  handleChange,
  taller1Options, 
  taller2Options, 
  comoSeEnteroOptions 
}) => {
  return (
    <div className="informacion-congreso">
      <h2 style={{
        fontSize: '1.5rem',
        fontWeight: '600',
        color: '#1f2937',
        marginBottom: '1rem',
        display: 'flex',
        alignItems: 'center'
      }}>
        <span style={{
          backgroundColor: '#ddd6fe',
          color: '#7c3aed',
          width: '32px',
          height: '32px',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginRight: '0.75rem',
          fontWeight: 'bold',
          fontSize: '0.875rem'
        }}>3</span>
        Información del Congreso
      </h2>
      
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
        {/* Grupo 1: Sesión de Taller #1 y Sesión de Taller #2 */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '3rem'
        }}>
          <div style={{ marginBottom: '1rem' }}>
            <label style={{ display: 'block', fontSize: '1rem', fontWeight: '500', color: '#374151', marginBottom: '0.5rem' }}>Sesión de Taller #1 2:00 pm - Sábado</label>
            <Select
              value={taller1Options.find(option => option.value === formData.tallerPreferencia)}
              onChange={(selectedOption) => handleSelectChange(selectedOption, 'tallerPreferencia')}
              options={taller1Options}
              placeholder="Selecciona un taller"
              isClearable
              styles={{
                control: (base) => ({
                  ...base,
                  minHeight: '52px',
                  fontSize: '16px',
                  borderColor: '#d1d5db',
                  '&:hover': { borderColor: '#9ca3af' }
                }),
                option: (base, state) => ({
                  ...base,
                  backgroundColor: state.isSelected ? '#3A7D5C' : 'white',
                  color: state.isSelected ? 'white' : '#1f2937',
                  fontWeight: state.isSelected ? 500 : 400,
                  '&:hover': {
                    backgroundColor: state.isSelected ? '#2d6147' : '#e8f5e8',
                    color: state.isSelected ? 'white' : '#1f2937'
                  }
                })
              }}
            />
          </div>

          <div style={{ marginBottom: '1rem' }}>
            <label style={{ display: 'block', fontSize: '1rem', fontWeight: '500', color: '#374151', marginBottom: '0.5rem' }}>Sesión de Taller #2 4:00 pm - Sábado</label>
            <Select
              value={taller2Options.find(option => option.value === formData.tallerPreferencia2)}
              onChange={(selectedOption) => handleSelectChange(selectedOption, 'tallerPreferencia2')}
              options={taller2Options}
              placeholder="Selecciona un taller"
              isClearable
              styles={{
                control: (base) => ({
                  ...base,
                  minHeight: '52px',
                  fontSize: '16px',
                  borderColor: '#d1d5db',
                  '&:hover': { borderColor: '#9ca3af' }
                }),
                option: (base, state) => ({
                  ...base,
                  backgroundColor: state.isSelected ? '#3A7D5C' : 'white',
                  color: state.isSelected ? 'white' : '#1f2937',
                  fontWeight: state.isSelected ? 500 : 400,
                  '&:hover': {
                    backgroundColor: state.isSelected ? '#2d6147' : '#e8f5e8',
                    color: state.isSelected ? 'white' : '#1f2937'
                  }
                })
              }}
            />
          </div>
        </div>

        {/* Necesidades Especiales y ¿Cómo se enteró? */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '3rem'
        }}>
          <div style={{ marginBottom: '1rem' }}>
            <label style={{ display: 'block', fontSize: '1rem', fontWeight: '500', color: '#374151', marginBottom: '0.5rem' }}>Necesidades Especiales</label>
            <textarea
              name="necesidadesEspeciales"
              value={formData.necesidadesEspeciales}
              onChange={handleChange}
              style={{
                width: '100%',
                padding: '0.75rem 1rem',
                border: '1px solid #d1d5db',
                borderRadius: '0.5rem',
                fontSize: '1rem',
                minHeight: '80px',
                resize: 'vertical',
                boxSizing: 'border-box'
              }}
              placeholder="Si tienes alguna condición de salud o necesidad médica y necesitas ayuda de nuestra parte, por favor indícalo aquí."
            />
          </div>

          <div style={{ marginBottom: '1rem' }}>
            <label style={{ display: 'block', fontSize: '1rem', fontWeight: '500', color: '#374151', marginBottom: '0.5rem' }}>¿Cómo se enteró del congreso?</label>
            <Select
              value={comoSeEnteroOptions.find(option => option.value === formData.comoSeEntero)}
              onChange={(selectedOption) => handleSelectChange(selectedOption, 'comoSeEntero')}
              options={comoSeEnteroOptions}
              placeholder="Selecciona una opción"
              isClearable
              styles={{
                control: (base) => ({
                  ...base,
                  minHeight: '52px',
                  fontSize: '16px',
                  borderColor: '#d1d5db',
                  '&:hover': { borderColor: '#9ca3af' }
                }),
                option: (base, state) => ({
                  ...base,
                  backgroundColor: state.isSelected ? '#3A7D5C' : 'white',
                  color: state.isSelected ? 'white' : '#1f2937',
                  fontWeight: state.isSelected ? 500 : 400,
                  '&:hover': {
                    backgroundColor: state.isSelected ? '#2d6147' : '#e8f5e8',
                    color: state.isSelected ? 'white' : '#1f2937'
                  }
                })
              }}
            />
          </div>
        </div>

        {/* Comentarios Adicionales */}
        <div style={{ marginBottom: '1rem' }}>
          <label style={{ display: 'block', fontSize: '1rem', fontWeight: '500', color: '#374151', marginBottom: '0.5rem' }}>Comentarios Adicionales</label>
          <textarea
            name="comentarios"
            value={formData.comentarios}
            onChange={handleChange}
            style={{
              width: '100%',
              padding: '0.75rem 1rem',
              border: '1px solid #d1d5db',
              borderRadius: '0.5rem',
              fontSize: '1rem',
              minHeight: '80px',
              resize: 'vertical',
              boxSizing: 'border-box'
            }}
            placeholder="Algún comentario o pregunta adicional"
          />
        </div>
      </div>
    </div>
  );
};

export default InformacionCongreso;
